import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import PropTypes from "prop-types";
import BlackBrickWithFadeDownAndLogo from "../../static/images/BlackBrickWithFadeDownAndLogo.png";
import TextLoop from "react-text-loop";
import AppRoutes from "../../constants/AppRoutes";

const LOGIN_BG_IMAGE_STYLE = {
    backgroundImage: `url(${BlackBrickWithFadeDownAndLogo})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "auto 100%",
    backgroundPosition: "center",
};

class LoginView extends React.Component {

    static propTypes = {
        isLoggingIn: PropTypes.bool.isRequired,
        isFailed: PropTypes.bool.isRequired
    };

    handleLoginStart = (event) => {
        EventPublisher.publish(UIInteractionEvents.FACEBOOK_LOGIN_BUTTON_CLICKED, {});
    };

    handleLoginFailedAlertClose = (event) => {
        EventPublisher.publish(UIInteractionEvents.LOGIN_FAILED_ALERT_CLOSE, {});
    };

    render() {
        const icon = this.props.isLoggingIn ?
            <span className="spinner-border spinner-border-sm mr-2"/> :
            <i className="fab fa-facebook-square mr-2"/>;

        const privateRouteWarning =
            window.location.pathname !== AppRoutes.LOGIN ?
                (
                    <div>
                        <div className="row justify-content-center">
                            <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                <h4 className="alert-heading">
                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    Private Page
                                </h4>
                                <p>
                                    The content on the page you are attempting to visit is private and requires you to
                                    be logged in to the site to view it.  Please log in to continue.
                                </p>
                            </div>
                        </div>
                    </div>
                ):
                null;

        const failedAlert = this.props.isFailed ?
            (<div className="alert alert-warning alert-dismissible fade show">
                <h4 className="alert-heading">Oh No!</h4>
                <p>It looks like something went wrong with your login attempt.  Please try again.</p>
                <button
                    type="button"
                    className="close"
                    onClick={this.handleLoginFailedAlertClose}
                >
                    <span>&times;</span>
                </button>
            </div>):
            null;

        return (
            <div className="container mt-13vh">
                <div className="row justify-content-sm-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-header border-bottom-box">
                                Register / Login
                            </div>
                            <div className="card-body text-center">
                                {privateRouteWarning}
                                <div className="row justify-content-center">
                                    <div className="col-12 text-light m-0">
                                        <div className="w-100" style={LOGIN_BG_IMAGE_STYLE}>
                                            <div className="row mt-2 pt-3 pb-20vh">
                                                <div className="col-6 text-right border-right-box">
                                                    <h3 className="font-weight-bolder">
                                                        Your
                                                        <br/>
                                                        <TextLoop
                                                                mask={true}
                                                                springConfig={{ stiffness: 180, damping: 8 }}
                                                                className="bold-contents-text text-white-outline"
                                                        >
                                                            <span className="text-cuvered-pink">Brick</span>
                                                            <span className="text-cuvered-purple">Window</span>
                                                            <span className="text-cuvered-dark-blue">Fence</span>
                                                            <span className="text-cuvered-blue">Trunk</span>
                                                            <span className="text-cuvered-light-blue">Wall</span>
                                                        </TextLoop>
                                                        <br/>
                                                        is
                                                        <br/>
                                                        showing.
                                                        <br/>
                                                        Get
                                                        <br/>
                                                        <span className="brand-text">Cuvered</span>
                                                    </h3>
                                                </div>
                                                <div className="col-6 text-left">
                                                    <h3 className="font-weight-bolder">
                                                        Your
                                                        <br/>
                                                        <TextLoop
                                                            mask={true}
                                                            springConfig={{ stiffness: 180, damping: 8 }}
                                                            className="bold-contents-text  text-white-outline"
                                                        >
                                                            <span className="text-cuvered-light-blue">Product</span>
                                                            <span className="text-cuvered-pink">Business</span>
                                                            <span className="text-cuvered-purple">Show</span>
                                                            <span className="text-cuvered-dark-blue">Charity</span>
                                                            <span className="text-cuvered-blue">Event</span>
                                                        </TextLoop>
                                                        <br/>
                                                        is
                                                        <br/>
                                                        lit.
                                                        <br/>
                                                        Get it
                                                        <br/>
                                                        <span className="brand-text">Cuvered</span>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row-cols-1">
                                    <button
                                        onClick={this.handleLoginStart}
                                        className="btn btn-lg btn-primary"
                                        disabled={this.props.isLoggingIn}
                                    >
                                        {icon}
                                        Continue with Facebook
                                    </button>
                                </div>
                                <div className="row-cols-1 mb-1 text-left">
                                    {failedAlert}
                                </div>
                            </div>
                            <div className="card-footer border-top-box text-center">
                                <small className="text-muted">
                                    By continuing you agree to our
                                    <a href="https://cuvered.com/terms-of-service" target="_blank" rel="noreferrer" className="text-cuvered-pink pr-1 pl-1">
                                        Terms of Service
                                    </a>
                                    and our
                                    <a href="https://cuvered.com/privacy-policy" target="blank" rel="noreferrer" className="text-cuvered-purple pl-1">
                                        Privacy Policy
                                    </a>.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginView;
